import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useLanguageCode } from '@procureai/ui-mui';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

export type ActiveCellValue = Union.Nullable<Union.Nullable<Record<string, any>>>;

interface I18nCellProps<R extends GridValidRowModel = any> {
  value: ActiveCellValue;
  row: R;
}

export const I18nCell = <R extends GridValidRowModel = any>({ value }: I18nCellProps<R>) => {
  const { languageCode } = useLanguageCode();
  if (isNil(value)) {
    return <>{NULLISH_CELL_VALUE}</>;
  }
  return <>{value[languageCode.toUpperCase()]}</>;
};
